<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <div
      v-if="patient"
      class="structure"
    >
      <span class="structure__heading">
        <i
          class="far fa-id-card-alt mr-2"
          aria-hidden="true"
        />
        {{ $tc('global.identifier', 2) }}
      </span>
      <b-row class="mt-1">
        <b-col
          v-for="(identifier, i) in patient.patientIdentifiers"
          :key="i"
          lg="4"
          md="6"
        >
          <div class="structure__data">
            <small>
              {{ identifier.identifierType.name }}
              <i
                v-if="identifier.center"
                v-tooltip="identifier.center.name"
                class="ml-1 far fa-clinic-medical"
                aria-hidden="true"
              />
            </small>
            <h4
              v-testing="`identifier-${identifier.identifierType.name}`"
              class="collapsable-card-title inside"
            >
              {{ identifier.paiIdentifier }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-else
      class="empty-block my-3"
      style="opacity: .3"
    />
  </b-col>
</template>

<script>
export default {
    name: 'PatientIdentifiersCard',
    props: {
        patient: { type: Object },
        customClass: { type: Array }
    }
}
</script>
